export default "__VITE_ASSET__D1bEVS1d__"